import { supabase } from '@/services/supabase'

/**
 * Get the current Supabase auth token for API requests.
 * Use this for direct fetch/SSE calls that bypass the axios interceptor.
 * Throws if no session exists.
 */
export async function getAuthToken(): Promise<string> {
  const { data: { session } } = await supabase.auth.getSession()
  if (!session?.access_token) {
    throw new Error('User not authenticated')
  }
  return session.access_token
}
